/**
 * 予約の表示系ヘルパー（ステータス・時刻・指名）。
 * 画面をまたいで使うためコンポーネントから切り出し
 */

export const RESERVATION_STATUS_LABEL = {
  tentative: '仮予約',
  confirmed: '確定',
  checked_in: '来店中',
  completed: '完了',
  canceled: 'キャンセル',
}

export const RESERVATION_STATUS_COLOR = {
  tentative: 'grey',
  confirmed: 'primary',
  checked_in: 'success',
  completed: 'grey lighten-1',
  canceled: 'error',
}

export const reservationStatusLabel = status => RESERVATION_STATUS_LABEL[status] || status || ''

export const reservationStatusColor = status => RESERVATION_STATUS_COLOR[status] || 'grey'

/**
 * time型カラムはISO文字列（ダミー日付付き）で返るためHH:mmを抽出する。
 *
 * @param {string|null} timeStr
 * @returns {string|null}
 */
export const reservationTime = timeStr => {
  if (!timeStr) return null
  const match = String(timeStr).match(/(\d{2}):(\d{2})/)

  return match ? `${match[1]}:${match[2]}` : null
}

/**
 * 指名の表示文字列（新形式の複数指名を優先、旧nominatedUserはフォールバック）。
 *
 * @param {object} attrs 予約のattributes相当（nominations / nominatedUser を持つ）
 * @param {string} fallback 指名なしのときに返す文字列
 * @returns {string|null}
 */
/**
 * 来店処理（卓作成）の前に入力が必要な項目のラベルを返す。
 * 指名がある予約はコース必須（来店処理のセット計上に使われる）。
 * 店舗側の予約フォームと同じルール（キャストアプリの作成には適用しない）
 *
 * @param {object} attrs 予約のattributes相当（nominations / course を持つ）
 * @returns {string[]} 不足項目のラベル（不足なしは空配列）
 */
export const checkInMissingItems = attrs => {
  const missing = []
  const nominations = (attrs && attrs.nominations) || []
  if (nominations.length > 0 && !attrs.course) missing.push('コース')

  return missing
}

export const nominationSummary = (attrs, fallback = '-') => {
  const nominations = attrs.nominations || []
  if (nominations.length > 0) {
    return nominations.map(n => `${n.userName}(${n.nominationName})`).join('・')
  }

  return attrs.nominatedUser?.name || fallback
}
